// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__AUrFc","image":"Header_image__182NM","name":"Header_name__7-fQx","info":"Header_info__3qVUH","infoRow":"Header_infoRow__3p6DA"};